// extracted by mini-css-extract-plugin
export default {"root":"IconBalcony_root__ahWeE"};